module.exports = __webpack_public_path__ + "img/Pool1-8k-Fn5.8c7e3946.gif";